<template>
	<div class="ztbox">
		<!--<div class="ztheader">
	</div>-->
		<div class="ztcenter">
			<div class="centerone flex spa-bet">
				<div class="centerleft">
					<div class="leftitem">
						<img src="@/assets/images/xin/szw2.png" class="leftimg" alt="" />
						<div>
							<p class="lefttext1">{{ sj.wkCount }}个</p>
							<p class="lefttext2">思政微课</p>
						</div>
					</div>

					<div class="leftitem">
						<img src="@/assets/images/xin/szw2.png" class="leftimg" alt="" />
						<div>
							<p class="lefttext1">{{ sj.courseCount }}门</p>
							<p class="lefttext2">课程数量</p>
						</div>
					</div>
					<div class="leftitem">
						<img src="@/assets/images/xin/szw2.png" class="leftimg" alt="" />
						<div>
							<p class="lefttext1">{{ sj.majorCount }}个</p>
							<p class="lefttext2">专业数量</p>
						</div>
					</div>
					<div class="leftitem">
						<img src="@/assets/images/xin/szw2.png" class="leftimg" alt="" />
						<div>
							<p class="lefttext1">{{ sj.majorRate }}%</p>
							<p class="lefttext2">专业覆盖率</p>
						</div>
					</div>
					<div class="leftitem">
						<img src="@/assets/images/xin/szw2.png" class="leftimg" alt="" />
						<div>
							<p class="lefttext1">{{ sj.teacherCount }}人</p>
							<p class="lefttext2">参与教师</p>
						</div>
					</div>
					<div class="leftitem">
						<img src="@/assets/images/xin/szw2.png" class="leftimg" alt="" />
						<div>
							<p class="lefttext1">{{ sj.schoolRate }}%</p>
							<p class="lefttext2">学校覆盖率</p>
						</div>
					</div>
				</div>
				<div class="centerright">
					<div class='onetitle'>思政微课建设情况
						<a-select v-model="year" style="width: 100px; margin-left: 10px;" @change="handleChange"
							:dropdownClassName="'customClass'">
							<a-select-option value="2023">2023</a-select-option>
							<a-select-option value="2022">2022</a-select-option>
							<a-select-option value="2021">2021</a-select-option>
						</a-select>
					</div>
					<div class="onebg" id="hh"></div>
				</div>
				<div class="centerright" style="width:29%;">
					<div class="onetitle2">各地区学校覆盖率</div>
					<div class="onebg" id="fgl"></div>
				</div>
			</div>
			<div class="centerone flex spa-bet" style="padding-bottom:20px;">
				<div class="centeritem">
					<div class="onetitle1">微课类型分布</div>
					<div class="onebg1" id="main"></div>
				</div>
				<div class="centeritem">
					<div class="onetitle1">微课思政元素</div>
					<div class="onebg1" ref="wordChart"></div>
				</div>
				<!-- <div class="centeritem" style="width:29%;">
		   	 <div class='onetitle2'>思政元素占比</div>
		   	 <div class="onebg1" id="mg"></div>
		   </div> -->
				<div class="centeritem" style="width:29%;">
					<div class='onetitle2'>专业建设</div>
					<div class="onebg1">
						<div style="
		            display: flex;
		            flex: 1;
		            overflow: hidden;
		            flex-direction: column;
		          ">
							<table class="tables">
								<colgroup>
									<col width="40%" />
									<col width="30%" />
									<col width="30%" />
									<col width="8px" />
								</colgroup>
								<thead>
									<tr>
										<th>专业大类</th>
										<th>专业</th>
										<th>数量</th>
									</tr>
								</thead>
							</table>
							<div class="tables" style="width:100%;overflow: hidden;height:330px;overflow-y: auto;">
								<table class="tables">
									<colgroup>
										<col width="40%" />
										<col width="30%" />
										<col width="30%" />
									</colgroup>
									<tbody>
										<tr v-for="(item, index) in list" :key="index">
											<td>
												{{ item.categoryName }}
											</td>
											<td>
												{{ item.majorName }}
											</td>
											<td>
												{{ item.num }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!--<table class="tables">
		   	 		<thead>
		   	 			<tr>
		   	 				<th>专业大类</th>
		   	 				<th>专业</th>
		   	 				<th>数量</th>
		   	 			</tr>
		   	 		</thead>
		   	 		<tbody>
		   	 			<tr v-for="item in list">
		   	 				<td>
		   	 					{{item.categoryName}}
		   	 				</td>
		   	 				<td>
		   	 					{{item.majorName}}
		   	 				</td>
		   	 				<td>
		   	 					{{item.num}}
		   	 				</td>
		   	 			</tr>
		   	 		</tbody>
		   	 	</table>-->
						</div>
					</div>
				</div>
				<div class="centeritem" style="width:29%;">
					<div class="onetitle2">学校建设排行</div>
					<div class="onebg1">
						<div style="
		            display: flex;
		            flex: 1;
		            overflow: hidden;
		            flex-direction: column;
		          ">
							<table class="tables">
								<colgroup>
									<col width="10%" />
									<col width="60%" />
									<col width="30%" />
									<col width="8px" />
								</colgroup>
								<thead>
									<tr>
										<th>序号</th>
										<th>学校名称</th>
										<th>数量</th>
									</tr>
								</thead>
							</table>
							<div class="tables" style="width:100%;overflow: hidden;height:330px;overflow-y: auto;">
								<table class="tables">
									<colgroup>
										<col width="10%" />
										<col width="60%" />
										<col width="30%" />
									</colgroup>
									<tbody>
										<tr v-for="(item, index) in xxlist" :key="index">
											<td>
												<img src="@/assets/images/bigData/num1.png" v-if="index == 0" alt />
												<img src="@/assets/images/bigData/num2.png" v-else-if="index == 1"
													alt />
												<img src="@/assets/images/bigData/num3.png" v-else-if="index == 2"
													alt />
												<div class="numbg" v-else>{{ index + 1 }}</div>
											</td>
											<td>{{ item.name }}</td>
											<td>{{ item.value }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts';
import HighCharts from "highcharts";
import 'echarts-wordcloud';
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
export default {
	data() {
		return {
			year: '2021',
			list: [],
			sj: {},
			xxlist: [],
		}
	},
	mounted() {

		this.getData();
		this.getProfess();
		// this.getRate();
		this.getwkType();
		this.getlist();
		this.getwkNum();
		this.getfgls();
		this.getxxlist();
		this.getWordChart()
	},
	methods: {
		getxxlist() {
			getAction('/analysis/wkSchoolMaxList', {
				applyType: '3',
			}).then((res) => {
				if (res.code == '200') {
					this.xxlist = res.result;
				}
			});
		},
		getfgls() {
			getAction('/analysis/areaSchoolRate', {
				applyType: '3',
			}).then((res) => {
				if (res.code == '200') {
					this.getfgl(res.result.headList, res.result.dataList);
				}
			});
		},
		getfgl(value, value1) {
			var myChart = echarts.init(document.getElementById("fgl"));
			let option = {
				title: {
					text: ""
				},
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow"
					},
					formatter: function(params) {
						const param = params[0]; // 只取第一个参数（对于单个系列）
						// const percent = ((param.value / 100) * 100).toFixed(1) + '%';
						return `${param.name}<br/>${param.value}%`;
					}
				},
				legend: {
					show: false
				},
				grid: {
					left: "3%",
					right: "4%",
					bottom: "3%",
					top: '1%',
					containLabel: true
				},
				xAxis: {
					type: "value",
					max: 100,
					axisLabel: {
						textStyle: {
							color: "#AADDFF"
						}
					},
					axisTick: {
						show: false
					},
					axisLine: {
						lineStyle: {
							color: "#AADDFF"
						}
					}
				},
				yAxis: {
					type: "category",
					data: value,
					axisLabel: {
						textStyle: {
							color: "#AADDFF"
						}
					},
					axisLine: {
						lineStyle: {
							color: "#68A8CC"
						}
					}
				},
				dataZoom: [{  // 数据缩放区域
					type: 'slider',  // 滑动条类型
					yAxisIndex: 0,   // 对应 yAxis 的索引
					start: 0,         // 初始窗口范围的起始百分比
					end: 50, // 初始窗口范围的结束百分比
					showDataShadow: false, // 是否显示数据阴影
					bottom: 20,
					textStyle: {
						color: 'transparent' // 修改滑块文字颜色
					},
					zoomLock: true,
					top: 20,
					left: 0,
					width: '10px',
					height: '80%',
				}],
				series: [
					{
						name: "",
						type: "bar",
						data: value1,
						showBackground: true,
						barWidth: 20,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 1, 1, 1, [
								{ offset: 0, color: "#83bff6" },
								{ offset: 0.5, color: "#188df0" },
								{ offset: 1, color: "#188df0" }
							]),
						},
						emphasis: {
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: "#002F69" },
									{ offset: 0.7, color: "#002F69" },
									{ offset: 1, color: "#002F69" }
								]),
								borderColor: '#0E48B3', // 边框颜色
								borderWidth: 2 // 边框宽度
							}
						}
					}
				]
			};
			myChart.clear();
			myChart.setOption(option);
		},
		getwkNum() {
			getAction('/analysis/wkNum', {
				applyType: '3',
			}).then((res) => {
				if (res.code == '200') {
					this.sj = res.result;
				}
			});
		},
		getlist() {
			getAction('/analysis/wkMajor', {
				applyType: '3',
			}).then((res) => {
				//				console.log(res,"222222");
				if (res.code == '200') {
					this.list = res.result;
				}
			});
		},
		getwkType() {
			getAction('/analysis/wkCourseType', {
				applyType: '3',
			}).then((res) => {
				//				console.log(res,"222222");
				if (res.code == '200') {
					let color = [{ itemStyle: { color: '#80CB4B' } }, { itemStyle: { color: '#517FD9' } }, { itemStyle: { color: '#FD8839' } }, { itemStyle: { color: '#FFC808' } }];
					let arr = [];
					for (var i = 0; i < res.result.length; i++) {
						arr.push({ name: res.result[i].name, value: res.result[i].value, itemStyle: color[i].itemStyle });
					}
					if (window.innerWidth > 1440) {
						this.glbt([70, 100], arr);
					} else {
						this.glbt([60, 80], arr);
					}
				}
			});
		},
		getRate() {
			getAction('/analysis/elementRate', {
				applyType: '3',
			}).then((res) => {
				//				console.log(res,"222222");
				if (res.code == '200') {
					let VALUE6 = [], VALUE11 = [];
					for (var i = 0; i < res.result.length; i++) {
						VALUE6.push(res.result[i].name);
						VALUE11.push(res.result[i].rate);
					}
					if (window.innerWidth > 1440) {
						this.mgt(['30%', '70%'], VALUE6, VALUE11);
					} else {
						this.mgt(['20%', '50%'], VALUE6, VALUE11);
					}
				}
			});
		},
		getProfess() {
			getAction('/analysis/groupProfession', {
				applyType: '3',
			}).then((res) => {
				//					console.log(res,"222222");
				if (res.code == '200') {
					let arr = [];
					let sj = res.result, total = 0;
					for (var i = 0; i < sj.length; i++) {
						let arr1 = [];
						arr1.push(sj[i].name);
						//							arr1.push(sj[i].rate);
						arr1.push(sj[i].value);
						arr.push(arr1);
					}
					if (window.innerWidth > 1440) {
						this.getMyChart5(180, 15, arr);
					} else {
						this.getMyChart5(140, 8, arr);
					}
				}
			});
		},
		getData() {
			getAction('/analysis/wkCityApply', {
				applyType: '3',
				year: this.year,
			}).then((res) => {
				//					console.log(res,"222222");
				if (res.code == '200') {
					this.gethh(res.result.cityList, res.result.dataList, res.result.rateList, res.result.schoolTypeList);
				}
			});
		},
		getMyChart5(value, value2, arr) {
			HighCharts.chart("bt", {
				chart: {
					type: "pie",
					options3d: {
						enabled: true,
						alpha: 50,
						beta: 0,
					},
					backgroundColor: null,
				},
				credits: {
					enabled: false,
				},
				title: {
					text: null,
				},
				legend: {
					enabled: true,
					itemHoverStyle: {
						color: '#02f4f5'  // 修改图例悬停时文本颜色为蓝色
					},
					itemStyle: {
						color: "#fff",
						fontSize: "10",
					},
					layout: 'horizontal', // 设置图例布局为水平布局
					align: "center", // 图例水平对齐方式
					verticalAlign: "top", // 图例垂直对齐方式// 设置图例区域宽度
					labelFormatter: function () {
						return this.name;
					}
				},
				plotOptions: {
					pie: {
						size: value,
						showInLegend: true,
						allowPointSelect: true, //每个扇块能否选中
						depth: 30, //饼图的厚度
						borderWidth: 2,
						borderColor: '#FFFFFF', // 设置边框颜色为白色
						dataLabels: {
							distance: value2, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
							enabled: true, //是否显示饼图的线形tip
							formatter: function (color) {
								//				              	console.log(this.point);
								return '<b style="color:' + this.point.color + ';font-size:14px;">' + this.point.y + '人(' + this.point.percentage.toFixed(1) + '%)</b></br>' + this.point.name + "";
							},
							style: {
								color: "#fff",
								textOutline: "none",
								fontSize: 14,
							},
						},
					},
				},
				series: [
					{
						name: "使用占比",
						data: arr,
						colors: ["#80CB4B", "#FFC808", "#FE8D37", "#517FD9",],
					},
				],
			});
		},
		getWordChart() {
			getAction('/analysis/wkszys', {
				applyType: '3',
			}).then((res) => {
				if (res.code == '200') {
					// let result=res.result.dataList;
					const result = res.result.dataList.map(item => ({
							name: item,
							value: (Math.random() * 3 + 13).toFixed(2) // 生成13-16之间的随机数，保留2位小数
					}));
					const chart = echarts.init(this.$refs.wordChart);
					chart.setOption({
						series: [{
							type: 'wordCloud',
							data:result,
							//  [
							// 	{ 'name': '胸怀理想', 'value': 13 },
							// 	{ 'name': '建功立业', 'value': 14 },
							// 	{ 'name': '民族自信', 'value': 16 },
							// 	{ 'name': '顽强拼搏', 'value': 15 },
							// 	{ 'name': '文化自信', 'value': 12 },
							// 	{ 'name': '奋发图强', 'value': 13 },
							// 	{ 'name': '刚健有为', 'value': 14 },
							// ],
							sizeRange: [16, 30],
							textStyle: { color: () => this.randomColor(), fontSize: '18-50' }
						}]
					});
					// this.gethh(res.result.cityList, res.result.dataList, res.result.rateList, res.result.schoolTypeList);
				}
			});
			
		},
		randomColor() {
			const h = Math.floor(Math.random() * 360);
			const s = 80 + Math.floor(Math.random() * 20);
			const l = 60 + Math.floor(Math.random() * 30);

			// HSL转RGB再转HEX
			const a = s * Math.min(l, 100 - l) / 100;
			const f = n => {
				const k = (n + h / 30) % 12;
				const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
				return Math.round(255 * color / 100).toString(16).padStart(2, '0');
			};
			return `#${f(0)}${f(8)}${f(4)}`;
		},
		handleChange() {
			this.getData();
		},
		mgt(arr, arr1, arr2) {

			var myChart = echarts.init(document.getElementById('mg'));
			var colorList = ['#4450BB', '#5F6CE6', '#58C9F7', '#F74D4E', '#FAC231'];
			var title = arr1;
			var dataValue = arr2;
			var dataList = title.map((item, index) => {
				return {
					name: item,
					value: dataValue[index],
					itemStyle: {
						color: colorList[index]
					},
				};
			});
			var center = ['50%', '50%'];
			var option = {
				color: colorList,
				series: [
					{
						type: 'pie',
						center: center,
						radius: arr, // 玫瑰图半径范围
						roseType: 'radius', // 玫瑰图类型
						label: {
							show: true,
							position: 'outside',
							alignTo: 'labelLine',
							//					            backgroundColor: '#fff',
							padding: [3, -3, 3, -3],
							formatter: function (params) {
								return `{a|${params.value}%}\n{b${params.dataIndex}|${params.name}}`
							},
							rich: {
								a: {
									//					                  padding: [10, 100, 10,100],
									fontSize: '14px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									color: '#fff',
									lineHeight: 24,
								},
								b0: {
									color: '#4450BB',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b1: {
									color: '#5F6CE6',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b2: {
									color: '#58C9F7',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b3: {
									color: '#F74D4E',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								},
								b4: {
									color: '#FAC231',
									fontSize: '12px',
									fontFamily: 'MicrosoftYaHei',
									fontWeight: 'bold',
									lineHeight: 24,
								}
							}
						},
						data: dataList,
					},
				],
			}
			myChart.clear();
			myChart.setOption(option);
		},
		glbt(arr, data) {

			//			 var data = [
			//	            {value: 1300, name: '公共基础课',itemStyle: {color: '#80CB4B'}},
			//	            {value: 1100, name: '专业基础课',itemStyle: {color: '#517FD9'}},
			//	            {value: 1100, name: '专业核心课',itemStyle: {color: '#FD8839'}},
			//	            {value: 1200, name: '实践类课程',itemStyle: {color: '#FFC808'}},
			//	        ];

			// 初始化图表
			var myChart = echarts.init(document.getElementById('main'));

			var currentIndex = 0;
			var oldIndex;

			// 图表配置和数据
			var option = {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					data: ['公共基础课', '专业基础课', '专业核心课', '实践类课程'],
					textStyle: {
						color: '#fff',
					},
					orient: 'horizontal',
					left: 'center',
					top: 'top'
				},
				series: [
					{
						name: '微课类型分布',
						type: 'pie',
						radius: arr,
						center: ['50%', '60%'],
						label: {
							show: false,
							position: 'center',
							formatter: function (params) {
								return '{b_style|' + params.value + '}\n{c_style|' + params.name + '}';
							},
							rich: {
								b_style: {
									padding: [0, 0, 10, 0],
									fontSize: 18,
									fontWeight: 400,
									color: function (params) {
										return params.color;
									}
								},
								c_style: {
									fontSize: 20,
									fontWeight: 'bold',
									color: '#fff'
								}
							}
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)',
								borderWidth: 0,
							},
							label: {
								show: true,
								fontSize: '14',
								fontWeight: 'normal'
							}
						},
						labelLine: {
							show: false
						},
						data: data
					}
				]
			};

			// 设置图表选项
			myChart.setOption(option);

			// 高亮饼图块函数
			function highlightPie(currentIndex, oldIndex) {
				// 取消高亮先前的饼图块
				if (oldIndex !== undefined && oldIndex !== currentIndex) {
					myChart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
						dataIndex: oldIndex
					});
				}

				// 高亮当前的饼图块
				myChart.dispatchAction({
					type: 'highlight',
					seriesIndex: 0,
					dataIndex: currentIndex
				});

				// 显示中心标签
				myChart.setOption({
					series: [{
						name: '微课类型分布',
						label: {
							show: true,
							formatter: '{b_style|' + data[currentIndex].name + '}\n{c_style|' + data[currentIndex].value + '}'
						}
					}]
				});
			}

			// 初始化时高亮第一个饼图块
			setTimeout(() => {
				highlightPie(0, 0);
			}, 50);

			// 绑定鼠标悬停事件
			myChart.on('mouseover', (params) => {
				if (params.componentType === 'series' && params.seriesType === 'pie') {
					oldIndex = currentIndex;
					currentIndex = params.dataIndex;
					highlightPie(currentIndex, oldIndex);
				}
			});
		},
		gethh(arr, arr1, arr2, arr3) {
			var myChart = echarts.init(document.getElementById('hh'));
			let option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						crossStyle: {
							color: '#999'
						}
					}
				},
				toolbox: {
					show: false,
				},
				legend: {
					//				    data: ['职业本科', '高职院校', '中职院校','技工院校','学校覆盖率'],
					data: arr3,
					textStyle: {
						color: '#fff',
					},
				},
				grid: {
					containLabel: true,
					left: 5,
					right: 15,
					bottom: 15,
					top: 50,
				},
				xAxis: [
					{
						type: 'category',
						data: arr,
						axisPointer: {
							type: 'shadow'
						},
						axisLabel: {
							textStyle: {
								color: "#AADDFF"
							},
							formatter: function (value) {
								let rowMAx = 4
								let overValue = ''
								for (let i = 0; i < value.length; i++) {
									if ((i % rowMAx == 0) && (i != 0)) {
										overValue += '\n'
										overValue += value[i]
									} else {
										overValue += value[i]
									}
								}
								return overValue
							},

						},
						axisTick: {
							show: false,
						},
						axisLine: {
							lineStyle: {
								color: "#AADDFF",
							}
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						name: '(建设数量)',
						min: 0,
						max: 250,
						interval: 50,
						axisLabel: {
							formatter: '{value}'
						},
						nameTextStyle: {
							color: '#63A1C6',
						},
						axisLabel: {
							textStyle: {
								color: "#63A1C6"
							},
						},
						axisLine: {
							lineStyle: {
								color: "#AADDFF",
							}
						}
					},
					{
						type: 'value',
						name: '(学校覆盖率)',
						min: 0,
						max: 100,
						interval: 20,
						axisLabel: {
							formatter: '{value}%'
						},
						nameTextStyle: {
							color: '#63A1C6',
						},
						axisLine: {
							lineStyle: {
								color: "#AADDFF",
							}
						},
						axisLabel: {
							textStyle: {
								color: "#63A1C6"
							},

						},
					}
				],
				series: [
					{
						name: arr3[0],
						type: 'bar',
						tooltip: {
							valueFormatter: function (value) {
								return value + '';
							}
						},
						itemStyle: {
							normal: {
								color: '#FF9C00',
							}
						},
						data: arr1[0]
					},
					{
						name: arr3[1],
						type: 'bar',
						tooltip: {
							valueFormatter: function (value) {
								return value + '';
							}
						},
						itemStyle: {
							normal: {
								color: '#0096FF',
							}
						},
						data: arr1[1]
					},
					{
						name: arr3[2],
						type: 'bar',
						tooltip: {
							valueFormatter: function (value) {
								return value + '';
							}
						},
						itemStyle: {
							normal: {
								color: '#1FD84B',
							}
						},
						data: arr1[2]
					},
					{
						name: arr3[3],
						type: 'bar',
						tooltip: {
							valueFormatter: function (value) {
								return value + '';
							}
						},
						itemStyle: {
							normal: {
								color: '#FFC808',
							}
						},
						data: arr1[3]
					},
					{
						name: arr3[4],
						type: 'line',
						yAxisIndex: 1,
						tooltip: {
							valueFormatter: function (value) {
								return value + '%';
							}
						},
						lineStyle: {
							color: '#38CEC1'  // 修改折线颜色
						},
						itemStyle: {
							color: '#fff',  // 点的填充颜色
							borderColor: '#38CEC1',  // 点的描边颜色
							borderWidth: 2  // 描边宽度
						},
						data: arr2
					}
				]
			};
			myChart.clear();
			myChart.setOption(option);
		}
	}
}
</script>

<style lang="scss" scoped>
p {
	margin: 0px;
	padding: 0px;
}

.flex {
	display: flex;
}

.spa-bet {
	justify-content: space-between;
}

.numbg {
	width: 24px;
	height: 26px;
	margin: 7px auto;
	background: url("../../assets/images/bigData/numbg.png") no-repeat;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	text-align: center;
	line-height: 26px;
	color: #a5b2c8;
}

.ztbox {
	height: auto;
	/*background: url("../../assets/images/bigdatas/banner.png") no-repeat;
  background-repeat: no-repeat;*/
	background-size: 100% 100%;
	/* padding:0px 20px 20px;*/
	box-sizing: border-box;
	flex: 1;

	/*.ztheader{
  	 height:80px;
  	 margin-bottom:10px;
  }*/
	.ztcenter {
		.centerleft {
			width: 216px;
			height: auto;

			.leftitem {
				width: 216px;
				height: 64px;
				background: url("../../assets/images/xin/szw1.png") no-repeat;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				margin-bottom: 10px;
				overflow: hidden;
				padding: 5px;
				box-sizing: border-box;
				display: flex;
				justify-content: flex-start;
				align-items: center;

				.leftimg {
					width: 43px;
					height: 43px;
					margin-right: 10px;
				}

				.lefttext1 {
					font-weight: bold;
					font-size: 20px;
					color: #ffd70e;
					line-height: 30px;
				}

				.lefttext2 {
					font-size: 16px;
					color: #ffffff;
					line-height: 24px;
				}
			}
		}

		.centerright {
			width: calc((71% - 236px));
			height: 434px;
			margin-bottom: 10px;

			.onetitle {
				height: 48px;
				background: url("../../assets/images/xin/szw3.png") no-repeat;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding-left: 30px;
				line-height: 48px;
				font-weight: bold;
				font-size: 20px;
				color: #02f4f5;
				display: flex;
				align-items: center;
			}

			.onebg {
				height: 386px;
				background: url("../../assets/images/xin/szw4.png") no-repeat;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding: 8px;
				box-sizing: border-box;
			}
		}

		.centeritem {
			width: 20%;
			height: auto;
		}

		.onetitle1 {
			height: 48px;
			background: url("../../assets/images/xin/szw5.png") no-repeat;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			padding-left: 30px;
			line-height: 48px;
			font-weight: bold;
			font-size: 20px;
			color: #02f4f5;
		}

		.onetitle2 {
			height: 48px;
			background: url("../../assets/images/xin/szw6.png") no-repeat;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			padding-left: 30px;
			line-height: 48px;
			font-weight: bold;
			font-size: 20px;
			color: #02f4f5;
		}

		.onebg1 {
			height: 396px;
			background: url("../../assets/images/xin/szw7.png") no-repeat;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			padding: 8px;
			box-sizing: border-box;
		}

		.tables {
			width: 100%;

			thead {
				tr {
					background-color: #082569;
					height: 50px;

					th {
						width: 25%;
						height: 50px;
						line-height: 50px;
						text-align: center;
						font-size: 16px;
						color: #8298fb;
					}
				}
			}

			tbody {
				tr {
					height: 40px;
					border-bottom: 1px solid #213e78;

					td {
						width: 25%;
						height: 40px;
						line-height: 40px;
						text-align: center;
						font-size: 16px;
						color: #fff;
						white-space: nowrap;
						/* 不换行 */
						overflow: hidden;
						/* 隐藏超出部分 */
						text-overflow: ellipsis;
					}
				}
			}
		}
	}

	@media screen and (max-width: 1440px) and (min-width: 1367px) {

		.onetitle,
		.onetitle1,
		.onetitle2 {
			font-size: 18px !important;
		}
	}

	@media screen and (max-width: 1366px) {

		.onetitle,
		.onetitle1,
		.onetitle2 {
			font-size: 16px !important;
		}

		.lefttext1 {
			font-size: 18px !important;
		}

		.lefttext2 {
			font-size: 14px !important;
		}

		.tables {
			width: 100%;

			thead {
				tr {
					background-color: #082569;
					height: 50px;

					th {
						width: 25%;
						height: 50px;
						line-height: 50px;
						text-align: center;
						font-size: 14px !important;
						color: #8298fb;
					}
				}
			}

			tbody {
				tr {
					height: 40px;
					border-bottom: 1px solid #213e78;

					td {
						width: 25%;
						height: 40px;
						line-height: 40px;
						text-align: center;
						font-size: 14px !important;
						color: #fff;
						white-space: nowrap;
						/* 不换行 */
						overflow: hidden;
						/* 隐藏超出部分 */
						text-overflow: ellipsis;
					}
				}
			}
		}
	}
}

.tables::-webkit-scrollbar {
	width: 3px;
	/* 横向滚动条的高度 */
}

/* 滚动条轨道 */
.tables::-webkit-scrollbar-track {
	background: #010d40;
	/* 轨道背景色 */
	border-radius: 10px;
	/* 轨道圆角 */
}

/* 滚动条滑块 */
.tables::-webkit-scrollbar-thumb {
	background: #4973c6;
	/* 滚动条颜色 */
	border-radius: 10px;
	/* 滚动条圆角 */
}

/* 滚动条滑块悬停效果 */
.tables::-webkit-scrollbar-thumb:hover {
	background: #4973c6;
	/* 鼠标悬停时滚动条颜色 */
}

::v-deep .ant-select-selection {
	background-color: #01297d;
	color: #fff;
	border-color: #2669e6;
}

::v-deep .ant-select-dropdown {
	background-color: #01297d;
	color: #fff;
}

::v-deep .ant-select-arrow {
	background-color: #01297d;
	color: #fff;
}

::v-deep .ant-radio-button-wrapper {
	color: #999;
	background-color: #0d308d;
	border-color: #ffffff00;
	border-radius: 0;
}
</style>

<style lang="scss">
.customClass {
	background: #01297d;

	.ant-select-dropdown-menu-item {
		background-color: #01297d;
		color: #fff;

		&:not(:last-child) {
			border-bottom: 1px solid #999;
		}

		&:hover:not(.ant-select-dropdown-menu-item-disabled) {
			background-color: #0f5bff;
		}
	}
}
</style>